import {
    getUserRequestBySearch,
    acceptToCourse,
    getUserAccept,
    rejectUserInCourse,
    removeUserInCourse,
    uploadUserInCourse,
    getUserBySearch,
    addUserInCourseBySearch,
    uploadUserToPreview,
    insertStudentToCourse,
    getCourseListAll,
    // getRoomStudentList,
    getRoomStudentMylib,
} from '@/service/mylib/list';
import { getTotalRequest } from '@/service/account/login';
import { getCourseById } from '@/service/course/course';
import { getRoom } from '@/service/room/room';
import { getUserGroup } from '@/service/account/manageUser';
import store from './../../../../../store';
export default {
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        updateLearnerRequest: {
            type: Function,
        },
        courseId: {
            type: String,
        },
        sectionID: {
            type: String,
        },
    },
    watch: {
        isOpen: async function (newValue) {
            if (newValue) {
                this.selectedRoom = null;
                await this.initialize();
                await this.getlistUser();
                this.getCourseDetail();
                this.setMainTabs();

                this.getRoomList();
            }
        },
        searchData() {
            this.searchUserInfo();
        },
        importDialog: async function (newValue) {
            if (newValue) {
                this.listRoom = await this.getRoomByCourseId();
            }
        },
    },
    computed: {
        headersUser() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.profile'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.fullName'
                    ),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.group'
                    ),
                    value: 'group',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.status'
                    ),
                    value: 'status',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.action'
                    ),
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                },
            ];
        },

        tableHeader() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.username'
                    ),
                    value: 'username',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.firstName'
                    ),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.lastName'
                    ),
                    value: 'lastname',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.email'
                    ),
                    value: 'email',
                    sortable: false,
                },
            ];
        },
        tableHeaderPreview() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.username'
                    ),
                    value: 'username',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.firstName'
                    ),
                    value: 'firstName',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.lastName'
                    ),
                    value: 'lastName',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.email'
                    ),
                    value: 'email',
                    sortable: false,
                },
            ];
        },
        tableHeaderFailPreview() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.username'
                    ),
                    value: 'username',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.remark'
                    ),
                    value: 'note',
                    sortable: false,
                },
            ];
        },
        headersSearch() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.profile'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.fullName'
                    ),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.group'
                    ),
                    value: 'group',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: '',
                    value: 'status',
                    sortable: false,
                    align: 'center',
                },
                //{ text: "Actions", value: "actions", sortable: false, align: "center" }
            ];
        },
        headersStudent() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.profile'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.fullName'
                    ),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.group'
                    ),
                    value: 'group',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.status'
                    ),
                    value: 'status',
                    sortable: false,
                },
            ];
        },
    },

    data: () => ({
        //user
        template:
            'https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/template/template-import.xlsx',
        userFile: '',
        main_tabs: '',
        page: 1,
        pageStd: 1,
        pageSearch: 1,
        pageCountUser: 0,
        pageCountStd: 0,
        pageCountSearch: 0,
        itemsPerPageUser: 10,
        loading: false,
        dialogDelete: false,
        dialogDeleteSuccess: false,
        searchData: '',
        search: null,
        selectedRoom: null,

        userRequest: [],
        userAccept: [],
        userSearch: [],
        studentRoom: [],

        userSearched: [],
        searchUserData: [],
        searchStudentUserInfo: null,

        pageFail: 1,
        pageFailCount: 1,
        pageSuccess: 1,
        pageSuccessCount: 1,
        pageRepeat: 1,
        pageRepeatCount: 1,

        acceptPage: 1,
        maxAcceptPage: 1,
        acceptLimit: 10,
        totalAccept: 0,
        checkAccept: null,

        requestPage: 1,
        maxRequestPage: 1,
        requestLimit: 10,
        totalRequest: 1,

        //dialog
        dialogAddUser: false,
        removeDialog: false,
        rejectDialog: false,
        excelDialog: false,
        importDialog: false,
        exp_date_dialog: false,
        dialogAddUserFromCourse: false,

        //remove item
        remove_item: '',
        reject_item: '',

        //item search
        item_search: '',

        //file
        tableData: [],

        pageUserUploadCount: 0,
        pageUserUpload: 1,
        excelFile: '',
        //urlDownload: "https://s3-amr.deknerd.com/template/template-import.xlsx",
        showExampleTable: true,
        showTabsResult: false,
        tabResult: 'fail',
        userUploadFail: [],
        userUploadRepeat: [],
        userUploadSuccess: [],

        //warrning
        textWarning: '',
        typeWarning: '',
        showWarnnig: false,

        // status add by search
        status_add: false,
        test_add: '',

        //course detail
        detail: [],
        listRoom: [],
        roomList: [],
        arrayRoom: [],
        courseList: [],
        selectRoom: null,
        // selectRoom: this.sectionID,
        room_headers: [
            {
                text: 'ชื่อกลุ่ม',
                align: 'start',
                sortable: false,
                value: 'title',
            },
            {
                text: 'ชื่ออาจารย์',
                value: 'teacher',
                sortable: false,
            },
            {
                text: 'จำนวนผู้เรียน',
                value: 'countStudent',
                sortable: false,
                align: 'center',
            },

            {
                text: 'เลือกกลุ่ม',
                sortable: false,
                align: 'center',
                value: 'select',
            },
        ],

        //date
        date: new Date().toISOString().substr(0, 10),
        nowdate: new Date().toISOString().substr(0, 10),
        menu1: false,
        date_type: 'type_life_time',
        data_type: '',
        actualTimeStamp: 0,
        actualTimeStampExp: 0,
    }),
    methods: {
        async initialize() {
            this.paramsG = {
                idcourse: this.courseId,
                page: this.page,
                limit: 10,
            };
            // await this.getRoomList();
            // console.log("room id: ",this.sectionID)
            await this.getUserGroupList();
        },
        closeDialogDateExp() {
            this.exp_date_dialog = false;

            this.date = new Date().toISOString().substr(0, 10);
            this.nowdate = new Date().toISOString().substr(0, 10);
            this.menu1 = false;
            this.date_type = 'type_life_time';
        },
        async getUserGroupList() {
            let result = await getUserGroup({
                idcourse: this.courseId,
            });
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.groupUsers.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.groupUsers.push({
                            title: group.title + ' -> ' + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.groupUsers.push({
                            title:
                                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            this.arrayGroup = this.groupUsers;
            // this.groupUsers = result;
            // this.filterGroupResult = result;
        },
        async getRoomList() {
            let result = await getCourseListAll();
            this.roomList = [];
            result.forEach(async (courselist) => {
                if (courselist.room.length > 0 && this.courseId != courselist._id) {
                    //this.roomList.push({
                    //header: courselist.title,
                    //});
                    courselist.room.forEach((rooms) => {
                        if (
                            rooms._id != this.sectionID &&
                            this.courseId != courselist._id
                        ) {
                            // if(rooms.countStudent > 0){
                            this.roomList.push({
                                idcourse: courselist._id,
                                idroom: rooms._id,
                                name: rooms.title,
                                countStudent: rooms.countStudent,
                                ownerRoom: rooms.teacher ? rooms.teacher.displayName : 'null',
                            });
                            // }
                        }
                    });
                    this.roomList.push({
                        divider: true,
                    });
                }
            });
        },
        async previewStudent(idcourse, idroom) {
            this.idCourse = idcourse;
            this.idRoom = idroom;
            this.studentRoom = [];
            let resultStudentList = [];
            // let resultStudent = await getRoomStudentList({
            //   idroom: this.idRoom,
            //   idcourse: this.idCourse
            // });
            let resultStudent = await getRoomStudentMylib({
                idroom: this.idRoom,
                idcourse: this.idCourse,
                idcourseadd: this.courseId,
                page: this.pageStd,
                limit: 10,
            });
            this.pageCountStd = resultStudent.maxPage;
            await resultStudent.data.forEach(async (student) => {
                await resultStudentList.push({
                    id: student.idStudent,
                    image: student.image,
                    name: student.firstName + ' ' + student.lastName,
                    status: student.ismylib,
                    group: await this.showGroupList(student.user_groups),
                    // group: student.user_groups
                });
            });
            this.studentRoom = resultStudentList;
        },
        async changePage(page) {
            this.pageStd = page;
            await this.previewStudent(this.idCourse, this.idRoom);
        },
        async changePageSearch(page) {
            this.pageSearch = page;
            await this.searchUserInfo();
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id
                            ? await userGroupOutput.push(group)
                            : null
                    )
            );
            return userGroupOutput;
        },
        async getRoomByCourseId() {
            let result = await getRoom({
                idcourse: this.courseId,
            });
            // this.pageCount = Math.ceil(result.length / this.limit)
            let tempRoom = [];
            await result.forEach(async (room) => {
                await tempRoom.push({
                    _id: room._id,
                    title:
                        room.title +
                        ' - ' +
                        room.teacher.displayName +
                        '(' +
                        room.countStudent +
                        ' ผู้เรียน )',
                    // title: room.title,
                    // countStudent: room.countStudent
                });
            });
        },

        setMainTabs() {
            this.main_tabs = 'accept';
        },
        //user
        async getlistUser() {
            await this.acceptListInfo();
            await this.requestListInfo();
        },
        async getCourseDetail() {
            let params = {
                id: this.courseId,
            };

            let detail = await getCourseById(params);
            this.detail = detail;
        },
        async searchUserInfo() {
            this.loading = true;
            this.userSearch = [];
            let resultSearch = [];
            if (this.searchData.length > 1) {
                // let data = {
                //   search: this.searchData,
                //   page: this.pageSearch,
                //   limit: 10
                // }
                let result = await getUserBySearch({
                    search: this.searchData,
                    page: this.pageSearch,
                    limit: 10,
                });
                this.pageCountSearch = result.maxPage;
                await result.data.forEach(async (user) => {
                    await resultSearch.push({
                        name: user.firstName + ' ' + user.lastName,
                        id: user._id,
                        status: await this.checkStatus(
                            user.myCourses,
                            user.myCoursesRequest
                        ),
                        // group: user.user_groups.length > 0 ? user.user_groups : [],
                        group: await this.showGroupList(user.user_groups),
                        image: user.image ? user.image : '',
                    });
                });
            }

            // this.userSearch = resultSearch.filter(user => user.status.length == 0);
            this.userSearch = resultSearch;
        },
        checkStatus(myCourses, myCoursesRequest) {
            let course = [];
            if (myCourses.length > 0) {
                for (let i = 0; i < myCourses.length; i++) {
                    if (myCourses[i]._id == this.courseId) {
                        course.push(myCourses[i]);
                    }
                }
            }
            if (myCoursesRequest.length > 0) {
                for (let i = 0; i < myCoursesRequest.length; i++) {
                    if (myCoursesRequest[i] == this.courseId) {
                        course.push(myCoursesRequest[i]);
                    }
                }
            }
            return course;
        },
        async requestListInfo() {
            this.loading = true;
            this.userRequest = [];
            let result = await getUserRequestBySearch({
                idcourse: this.courseId,
                idroom: this.sectionID,
                page: this.requestPage,
                limit: this.requestLimit,
            });
            this.maxRequestPage = result.maxPage;
            this.totalRequest = result.count;
            if (result) {
                this.loading = false;
                result.data.forEach(async (user) => {
                    this.userRequest.push({
                        image: user.image ? user.image : '',
                        name: user.firstName + ' ' + user.lastName,
                        id: user._id,
                        status: this.checkStatusTeacher(user.isTeacher),
                        acceptMylib: user.acceptMylib,
                        // group: user.user_groups
                        group: await this.showGroupList(user.user_groups),
                    });
                });
            }
        },
        checkStatusTeacher(teacherStatus) {
            if (teacherStatus === 'y') {
                return 'ครู';
            } else if (teacherStatus === 'w') {
                return 'รออนุมัติเป็นครู';
            } else {
                return 'ผู้เรียน';
            }
        },
        async acceptUser(item) {
            let data = {
                id: item.id,
            };
            let result = await acceptToCourse(data);
            if (result.acceptMylib == true) {
                let resultTotalRequest = await getTotalRequest();
                store.commit('setTotal', resultTotalRequest.course);
                this.getlistUser();
                this.updateLearnerRequest();
            }
        },
        async acceptListInfo() {
            this.loading = true;
            this.userAccept = [];

            let result = await getUserAccept({
                idcourse: this.courseId,
                idroom: this.sectionID,
                page: this.acceptPage,
                limit: this.acceptLimit,
            });
            this.maxAcceptPage = result.maxPage;
            this.totalAccept = result.count;
            if (result) {
                this.loading = false;
                result.data.forEach(async (user) => {
                    this.userAccept.push({
                        image: user.image ? user.image : '',
                        name: user.firstName + ' ' + user.lastName,
                        id: user._id,
                        status: this.checkStatusTeacher(user.isTeacher),
                        acceptMylib: user.acceptMylib,
                        // group: user.user_groups
                        group: await this.showGroupList(user.user_groups),
                    });
                });
            }
        },
        async changeAcceptPage(page) {
            this.acceptPage = page;
            await this.acceptListInfo();
        },
        async rejectUser() {
            if (this.checkAccept == true) {
                let data = {
                    id: this.reject_item,
                };
                let result = await rejectUserInCourse(data);
                if (result) {
                    let resultTotalRequest = await getTotalRequest();
                    store.commit('setTotal', resultTotalRequest.course);
                    this.dialogDelete = false;
                    this.checkAccept = null;
                    await this.getlistUser();
                    this.updateLearnerRequest();
                }
            } else {
                let data = {
                    id: this.reject_item,
                };
                let result = await removeUserInCourse(data);
                if (result) {
                    let resultTotalRequest = await getTotalRequest();
                    store.commit('setTotal', resultTotalRequest.course);
                    this.dialogDelete = false;
                    this.checkAccept = null;
                    await this.getlistUser();
                    this.updateLearnerRequest();
                }
            }
        },
        async changeRequestPage(page) {
            this.requestPage = page;
            await this.requestListInfo();
        },
        // async removeUser() {
        //   let data = {
        //     id: this.remove_item
        //   };
        //   let result = await removeUserInCourse(data);
        //   if (result) {
        //     this.dialogDelete = false;
        //     this.checkAccept = null;
        //     await this.getlistUser();
        //   }
        // },
        closeDialog() {
            this.isClose();

            this.studentRoom = [];
            this.selectedRoom = null;
            this.userSearch = [];
            this.pageStd = 1;
            this.pageSearch = 1;
            this.searchData = '';
            this.textWarning = '';
            this.typeWarning = '';
            this.showWarnnig = false;
        },
        closeDialogReject() {
            this.dialogDelete = false;
            this.checkAccept = null;
            this.remove_item = '';
        },
        // openRemoveDialog(item) {
        //   console.log(item);
        //   this.remove_item = item.id;
        // },
        openRejectDialog(item) {
            this.checkAccept = item.acceptMylib;
            this.reject_item = item.id;
            this.dialogDelete = true;
        },
        closeExcelDialog() {
            if (this.excelFile.length !== 0) {
                console.log(this.excelFile.length);
            } else {
                this.excelDialog = false;
                this.tableData = [];
                this.showExampleTable = true;
                this.showTabsResult = false;
            }
        },
        closeUserExcelDialog() {
            if (this.excelFile.length !== 0) {
                console.log(this.excelFile.length);
            } else {
                this.excelDialog = false;
                this.tableData = [];
                this.showExampleTable = true;
                this.showTabsResult = false;
            }
        },
        closeImportDialog() {
            this.importDialog = false;
            this.tableData = [];
            this.showExampleTable = true;
            this.showTabsResult = false;
            this.userUploadFail = [];
            this.userUploadRepeat = [];
            this.userUploadSuccess = [];
            this.selectRoom = null;
        },
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;
            if (isLt1M) {
                return true;
            }
            this.$message({
                message: 'Please do not upload files larger than 1m in size.',
                type: 'warning',
            });
            return false;
        },
        handleSuccess({ results }, file) {
            this.excelFile = file;
            this.tableData = results;
            this.showExampleTable = true;
        },
        async handlePreviewSuccess({ results }, file) {
            this.excelFile = file;
            this.tableData = results;
            this.showExampleTable = true;
            await this.uploadFilePreview();
        },
        async uploadFilePreview() {
            //  this.excelFile
            let data = {
                idcourse: this.courseId,
                arrayusername: this.tableData,
            };
            this.userUploadFail = [];
            this.userUploadRepeat = [];
            this.userUploadSuccess = [];
            let result = await uploadUserToPreview(data);
            if (result) {
                this.showExampleTable = false;
                this.showTabsResult = true;
                this.userUploadSuccess = result.student_accept;
                this.userUploadFail = result.student_error.map((error) => ({
                    ...error,
                    note: 'ไม่มีในระบบ',
                }));
                this.userUploadRepeat = result.student_isHave;
            }
        },
        async uploadFile() {
            //  this.excelFile
            let data = {
                idcourse: this.courseId,
                // idprice:
                //   this.detail.prices && this.detail.prices.length !== 0
                //     ? this.detail.prices[0]._id
                //     : "",
                excel: this.tableData,
                idroom: this.sectionID,
            };
            this.userUploadFail = [];
            this.userUploadRepeat = [];
            this.userUploadSuccess = [];
            let result = await uploadUserInCourse(data);
            if (result) {
                this.showExampleTable = false;
                this.showTabsResult = true;
                for (let i = 0; i < result.student_accept.length; i++) {
                    this.tableData.forEach((user) => {
                        if (result.student_accept[i] === user.username) {
                            this.userUploadSuccess.push(user);
                        }
                    });
                }
                for (let i = 0; i < result.student_error.length; i++) {
                    this.tableData.forEach((user) => {
                        if (result.student_error[i] === user.username) {
                            this.userUploadFail.push(user);
                        }
                    });
                }
                for (let i = 0; i < result.student_isHave.length; i++) {
                    this.tableData.forEach((user) => {
                        if (result.student_isHave[i] === user.username) {
                            this.userUploadRepeat.push(user);
                        }
                    });
                }
            }
        },
        openExpDateDialog(type, item) {
            this.data_type = type;
            if (this.data_type == 'search') {
                this.item_search = item;
            }
            this.exp_date_dialog = true;
        },

        async addUserByUser() {

            if (this.data_type == 'search' || this.data_type == 'clone') {
                this.addUserbySearch();
                this.closeDialogDateExp();
                this.previewStudent(this.idCourse, this.idRoom);
            } else {
                this.importStudentToCourse();
                this.closeDialogDateExp();
                this.previewStudent(this.idCourse, this.idRoom);
            }
        },

        async addUserbySearch() {
            this.loading = true;
            if (this.data_type == 'search') {
                let index = this.userSearch.indexOf(this.item_search);
                let dt_start = new Date(this.date + ',' + '00' + ':' + '00');

                var startTime = dt_start.setTime(
                    dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
                );
                this.actualTimeStamp = startTime;
                let expDate = new Date().toISOString().substr(0, 10);
                if (expDate == this.date) {
                    let actualDate = new Date();
                    let endOfDayDate = new Date(
                        actualDate.getFullYear(),
                        actualDate.getMonth(),
                        actualDate.getDate(),
                        23,
                        59,
                        59
                    );
                    let setTimeSatmpEnOfDay = endOfDayDate.setTime(
                        endOfDayDate.getTime()
                    );
                    this.actualTimeStamp = setTimeSatmpEnOfDay;
                }
                let data = {
                    idcourse: this.courseId,
                    idstudent: this.item_search.id,
                    idroom: this.sectionID,
                    exp: this.date_type == 'type_spectify_exp' ? this.actualTimeStamp : 0,
                    pricing: 0,

                    // idprice:
                    //   this.detail.prices && this.detail.prices.length !== 0
                    //     ? this.detail.prices[0]._id
                    //     : ""
                };
                let result = await addUserInCourseBySearch(data);
                if (result.acceptMylib == true) {
                    this.userSearch[index].status.push({
                        text: 'เพิ่มสำเร็จ',
                    });
                    this.getlistUser();
                    this.searchUserInfo();
                    this.closeDialogDateExp();
                    this.loading = false;
                } else {
                    this.userSearch[index].status.push({
                        text: 'เพิ่มไม่สำเร็จ',
                    });
                    this.getlistUser();
                    this.searchUserInfo();
                    this.closeDialogDateExp();
                    this.loading = false;
                }
            } else {
                let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
                var expTime = dt_start.setTime(
                    dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
                );
                this.actualTimeStampExp = expTime;
                let expDate = new Date().toISOString().substr(0, 10);
                if (expDate == this.date) {

                    let actualDate = new Date();
                    let endOfDayDate = new Date(
                        actualDate.getFullYear(),
                        actualDate.getMonth(),
                        actualDate.getDate(),
                        23,
                        59,
                        59
                    );
                    let setTimeSatmpEnOfDay = endOfDayDate.setTime(
                        endOfDayDate.getTime()
                    );
                    this.actualTimeStampExp = setTimeSatmpEnOfDay;
                }
                // let resultAddStudent = [];
                this.studentRoom.forEach(async (students) => {
                    let data = {
                        idcourse: this.courseId,
                        idstudent: students.id,
                        idroom: this.sectionID,
                        exp:
                            this.date_type == 'type_spectify_exp'
                                ? this.actualTimeStampExp
                                : 0,
                        pricing: 0,
                        // idprice:
                        //   this.detail.prices && this.detail.prices.length !== 0
                        //     ? this.detail.prices[0]._id
                        //     : ""
                    };
                    // let result = await addUserInCourseBySearch(data);
                    await addUserInCourseBySearch(data);
                    // resultAddStudent = result;
                    this.studentRoom = [];

                    // if (resultAddStudent.room) {
                    //   console.log("เพิ่มไม่สำเร็จ");
                    //   this.closeDialogDateExp();
                    //   console.log("student list : ", this.studentRoom);
                    // }
                });
                this.getlistUser();
                this.closeDialogDateExp();
                this.closeDialog();
                this.loading = false;
            }
        },

        warnnig(text, type) {
            this.textWarning = text;
            this.typeWarning = type;
            this.showWarnnig = true;
        },

        async importStudentToCourse() {
            let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
            var startTime = dt_start.setTime(
                dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
            );

            let data = {
                idcourse: this.courseId,
                // idprice:
                //   this.detail.prices && this.detail.prices.length !== 0
                //     ? this.detail.prices[0]._id
                //     : "",
                exp: this.date_type == 'type_spectify_exp' ? startTime : 0,
                pricing: 0,
                arrayusername: this.tableData,
                // idroom: this.selectRoom
                idroom: this.sectionID,
            };
            await insertStudentToCourse(data);
            await this.getlistUser();
            await this.closeImportDialog();
        },
    },
};
